import { Box, SxProps, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import { setConsentModalDetails } from "../../../../Redux/reducers/consentSlice";
import { createConsentBlockSkeleton } from "../../../../utils/consent";

type Props = {
  blockType: {
    key: string;
    icon: any;
    type: string;
    title: string;
  };
};

const containerStyle: SxProps = {
  display: "flex",
  alignItems: "center",
  px: 1.5,
  height: "44px",
  border: "1px solid",
  borderColor: "#E5E7EB",
  borderRadius: "10px",

  "&:not(:last-child)": {
    mb: 2,
  },
};

const ConsentPickerItem = (props: Props) => {
  const { blockType } = props;

  const dispatch = useAppDispatch();
  const blocks = useAppSelector((state) => state.consent.blocks);
  const editable = useAppSelector((state) => state.consent.editable);

  const handleSelectBlockType = () => {
    if (editable) {
      let newBlock: any = createConsentBlockSkeleton(blockType.type);
      newBlock.position = blocks.length + 1;

      if (newBlock) {
        dispatch(
          setConsentModalDetails({
            show: true,
            block: newBlock,
            modalIsEdit: false,
          })
        );
      }
    }
  };

  const Icon = blockType.icon;

  return (
    <Box
      sx={{
        ...containerStyle,
        "&:hover": {
          cursor: editable ? "pointer" : "default",
          bgcolor: "#EfEfEf",
        },
      }}
      onClick={handleSelectBlockType}
    >
      {Icon && <Icon />}
      <Typography
        color="text.primary"
        variant="body1"
        fontWeight={"medium"}
        sx={{ ml: 1 }}
      >
        {blockType.title}
      </Typography>
    </Box>
  );
};

export default ConsentPickerItem;
